var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemisOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.69 524.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.44,111.2s-4.98,5.21-2.94,11.77,4.53,26.94,8.15,30.34,19.02,12.19,26.72,27.6,17.66,18.81,23.55,17,6.11-13.36,6.11-13.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.02,185.38s2.49,3.77,1.74,8-8.15,9.96-8.15,9.96c0,0-10.57,7.4-8.6,12.53s20,47.47,13.89,72.6-6.82,37.81-5.56,41.89,2.16,50.04,14.16,62.49,17.51,13.51,20.08,19.85,.3,14.04,0,16,.15,24-3.02,30.64-14.94,13.89-16.91,14.94-12.98,12.53-9.51,16.91,9.21-1.51,13.13-1.81-1.81,4.53-1.21,5.74,7.25,13.89,14.64,13.74,11.47,1.51,11.47,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.47,472.1s-1.5,7.47,2.23,13.36,17.48,17.19,20.04,16.64c6.79-1.47,3.43,8.26,3.43,8.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.06,319.09s-8.49,30.07-8.94,36.64-3.62,22.19,5.89,30.11,36,36.45,35.32,48.45-18.49,21.51-19.62,22.11-2.72,1.81-2.34,2.94,17.13,2.19,19.32,1.06,6.42-9.28,8.75-10.94,14.11-7.19,14.11-12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.91,108.93s-5.89,4.98-6.34,9.51,0,12.45,0,12.45c0,0,7.7,1.06,7.43,6.42s3.06,12,1.32,14.11-10.64,7.02-11.77,12.98,6.77,17.89,6.14,20.6-5.59,10.19-.06,16.75,6.37,10.87,4.37,12.91-5.38,7.7-4.37,16.98-4.42,44.38-4.42,44.38c0,0-4.3,0-4.3,4.53s-1.36,11.55-4.08,14.49-5.89,10.42-6.34,15.4-.45,9.51,3.85,13.58,17.21,32.72,18.34,38.6,2.94,22.75,4.64,26.26,5.09,9.4,5.09,9.4c0,0,5.32,11.89,7.58,19.81s13.55,11.66,13.55,19.06c0,0,10.79,9.57,10.79,23.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.59,320.63s-3.77,30.49-19.02,51.77,12.91,57.96,13.74,76.68c.21,4.67-1.96,11.54-1.96,11.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.59,320.63s-3.62,50.49,11.09,64.75,27.64,19.9,27.64,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.4,376.14s-1,13.02,3.98,22.22,14.34,40.15,9.96,62.52c0,0-4.38,20.19-12.08,27.59s-18.87,14.19-17.81,15.55,6.94,5.13,17.81,2.72c8.58-1.91,21.13-15.55,22.19-19.47s-.54-11.02-.7-15.62,7.66-27.06,10.17-40.98c1.86-10.33-11.43-34.42-12.34-38.34s4.23-19.32,4.23-19.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.27,107.46s-.23,25.36,7.7,32.38,15.96,12.11,17.09,16.08,24.34,67.7,25.7,73.36,6.57,56.72,9.06,59.55,9.4,8.49,10.19,12.34-1.7,4.3-1.7,4.3c0,0,.94,2.49-.6,3.66s-1.81,1.21-1.81,1.21c0,0,.45,2.68-1.17,3.51s-2.26,1.36-2.26,1.36c0,0,2.72,1.81,1.32,3.06s-7.06,2.83-10.19-6.94-18.19-78.23-19.7-82.3-19.01-46.62-20.45-48.94c-.92-1.47-2.42,4.49-2.42,4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.87,117.31s3.55,13.92,1.28,18.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.14,31.84s3.28,2.6,3.17,7.92-3.73,6.23,0,12.23,24.68,25.58,25.47,26.72,5.66,7.58,9.51,11.21,24.68,17.47,26.04,18.45c2.02,1.46,10.87,4.44,16.74,7.66s11.02,11.3,16.58,11.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.12,28.63s19.09,4.08,18.64,7.25-1.89,2.87-3.92,3.25-4.08-.45-4.08-.45c0,0,.75,2.19,.23,3.7s-2.19,5.74-5.06,4.91-5.81,.11-5.81,.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.27,28.65s-5.06,4.13-5.06,8.51-1.21,11.92,3.89,15.4,24.64,38.87,31.74,43.92,41.76,30.58,41.67,33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.29,77.46s3.25-2.57,13.58,.75,30.26,10.79,31.17,12.68,4.23,3.17,2.34,4.75-2.49,1.89-2.49,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.29,77.18s0,5.43,.6,7.53,.82,3.76,.82,3.76c0,0,26.92,4.9,29.12,4.56s2.72-.4,2.72-.4c0,0,2.09-4.3,4.47-3.28s3.85,4.25,3.34,5.66,4.08,1.47,4.36,3.68c0,0-.06,2.35-.42,3s4.84,5.15,6.08,9.11,4.02,3.96,4.73,3.91,3.76-.11,3.79,2.6-2.12,4.16-3.17,3.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.66,88.13c-.07,.83-.2,1.48-.41,1.84-1.37,2.43-3.53,4.24-3.7,5.43s2.97,2.94,3.31,3.57c1.47,2.38-.37,2.52-.57,3.65-.45,2.62,2.19,2.59,2.19,3.72s-1.77,2.6-1.19,5.32c.71,3.28,13.71,3.85,14.62,6.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.25,77.01h0c-.94-.71,1.89-8.36,2.93-8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.29,55.65s6.19-3.4,14.34-1.13,8.23,4.45,9.36,4.68,5.22,.23,7.97,9.28,5.39,8.91,4.71,13.36-1.13,7.47-2.64,8.23,.23,2.57-.6,3.7-2.04,1.89-2.04,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.31,115.41s6.57,4.33,7.56,8.55-.98,8.06-.98,8.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.91,120.28s2.72,8.41,4.84,9.79,3.99,4.27,4.08,5.41-.74,8.86-2.41,9.65-2.15,.79-2.15,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.8,85.02c-.29-2.46-17.54-11.01-25.86-13.78s-4.33-9.4-4.33-9.4c0,0,2.78-2.1,4.75-3.62,4.05-3.13,8.92-2.57,8.92-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.27,292.31l4.51-7.4s-2.04-2.24-.3-5.79,7.62-1.74,7.62-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.09,309.63s-1.32,7.67-4.71,8.13-6.42-3.85-10.79-4.75-10.11,3.09-10.11,3.09c0,0,12.91,.91,13.28,9.06s-5.13,7.09-5.13,7.09c0,0,4.43,4.62,2.91,6.6s-7.7,3-7.7,3c0,0-12.5,28.33-15.51,33.91s-79.25,141.55-79.25,141.55c0,0-.3,7.25,0,6.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.94,318.76s-1.5,2.17-.97,3.53,10.11,4.08,11.62,6.57,1.13,6.45,1.13,6.45c0,0-7.21-6.15-14.6-3.77s-5.02,7.28-5.02,7.28c0,0-4.11-.57-6.34,2.23s0,8.87,0,8.87c-16.08,19.2-62.89,102.04-102.49,169.96l-6.19,4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.1,277.38s4.38,2.49,2.72,6.79-4.75,3.4-4.75,3.4l-5.19,9.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.78,98.35s-2.09,3.79-4.02,3.85-2.32-1.92-2.32-1.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.56,
    y1: 129.86,
    x2: 26.2,
    y2: 227.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.39,
    y1: 133.1,
    x2: 136.46,
    y2: 230.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.97,
    y1: 230.52,
    x2: 130.39,
    y2: 133.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.21,
    y1: 229.09,
    x2: 130.39,
    y2: 133.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.56,
    y1: 129.86,
    x2: 3.56,
    y2: 228.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.29,
    y1: 228.13,
    x2: 25.56,
    y2: 129.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.31,227.91s-26,1.47-28.49,4.53,8.88,9.85,25.61,9.51,24.77-9.28,24.09-11.43-21.2-2.6-21.2-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.88,226.5s-25.26-.45-25.38,2.26,15.96,10.53,27.62,8.83c11.66-1.7,23.09-9.17,22.64-9.4s-24.89-1.7-24.89-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.21,276.03s8.38,10.87,13.81,31.7,15.28,32.38,11.04,54.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.59,281.84s.75,11.17-7.25,31.7-27.08,46.35-27.8,56.62,6.63,27.31,6.63,27.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.6,201.66s-18.44,11.66-17.99,19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.05,226.55s-22.57-12.03-24.05-17.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.6,190.67s-9.03,11.77-17.27,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.64,3.27c-3.02,2.45-8.17,1.14-6.7,8.01s1.17,11.03,1.17,11.03c0,0-19.09,84.36-18.87,90.7s6.23,11.89,9.4,13.64,46.95,5.87,50.91,6.43c2.64,.38,1.88,4.91,1.88,4.91,0,0,6.67-3.73,0-9.81-9.43-8.6-35.99-4.23-51.31-16.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.03,4.17s.25,1.14,2.7,4-6.28,13.27-6.89,16.42l-14.73,86.6s-10.42,14.49-16.75,14.26-28.08-2.81-32.83-1.74-6.34,5.9-6.34,5.9c0,0-7.86-5.39-3.62-9.34,9.74-9.08,46.87-1.92,48.68-8.41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 99.05,
    cy: 2.69,
    rx: 2.08,
    ry: 3.39,
    transform: "translate(71.97 98) rotate(-75.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.52,491.23s-2.06,12.57,10.84,13.92,29.22,3.62,29.22,3.62"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemisOutline);
export default __webpack_public_path__ + "static/media/themisOutline.503d3016d1198e9acca11068361cf04a.svg";
export { ForwardRef as ReactComponent };